<template>
                <div class="news-items mt54">
                    
                    <a href="/NewsDetail/55" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="/core/extend/kindeditor/attached/image/20220605/20220605033315_89988.jpg" alt="澳优码助力讲好中国故事 澳门企业荣获世博会首届宝船国际茶文化节“茶科技贡献奖”" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">04/24<span>2022</span></div></div>
                            <div class="info">
                                <div class="title">澳优码助力讲好中国故事 澳门企业荣获世博会首届宝船国际茶文化节“茶科技贡献奖”</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/54" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="/core/extend/kindeditor/attached/image/20220605/20220605033109_51635.png" alt="横琴创新应用“澳优码”亮相首届BEYOND国际科技创新博览会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/10<span>2021</span></div></div>
                            <div class="info">
                                <div class="title">横琴创新应用“澳优码”亮相首届BEYOND国际科技创新博览会</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/36" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1646042357149099.jpg" alt="星火体系 | “星火·链网”骨干节点（珠海横琴）创新应用——“澳优码”亮相澳门科技博览会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/07<span>2021</span></div></div>
                            <div class="info">
                                <div class="title">星火体系 | “星火·链网”骨干节点（珠海横琴）创新应用——“澳优码”亮相澳门科技博览会</div>
                                <div class="desc">12月2日-4日，首届BEYOND 国际科技创新博览会在澳门盛大召开。博览会由澳门科技总会(MTGA)主办，商务部外贸发展局、国务院国资委规划发展局、中国国际科技交流中心和中华医学会合办。大会聚焦前言科技，进一步释放澳门产业多元发展活力，促进澳门与国际科技界展开交流合作。“星火·链网”骨干节点（珠海横琴）的创新应用——“澳优码”亮相博览会。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/37" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1646041615210003.jpg" alt="“星火·链网”骨干节点（珠海横琴）上线发布 创新赋能数字贸易" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">12/01<span>2021</span></div></div>
                            <div class="info">
                                <div class="title">“星火·链网”骨干节点（珠海横琴）上线发布 创新赋能数字贸易</div>
                                <div class="desc">11月30日，2021粤港澳数字贸易创新应用峰会暨“星火·链网”骨干节点（珠海横琴）-横琴粤澳链发布会在粤澳合作中医药科技产业园举行。峰会上探讨了数字技术如何赋能数字贸易，助力横琴粤澳深度合作区及粤港澳大湾区高质量发展等议题,并宣布了“星火·链网”骨干节点（珠海横琴）-横琴粤澳链正式上线运行。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://baijiahao.baidu.com/s?id=1717935773616480599&amp;wfr=spider&amp;for=pc&amp;searchword=%E6%A8%AA%E7%90%B4%E7%B2%A4%E6%BE%B3%E9%93%BE" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="/static/upload/other/20220605/1654399679844795.jpeg" alt="粤港澳数字贸易提速！“横琴粤澳链”落地" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/30<span>2021</span></div></div>
                            <div class="info">
                                <div class="title">粤港澳数字贸易提速！“横琴粤澳链”落地</div>
                                <div class="desc"></div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/38" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1646041174993424.jpg" alt="“星火·链网”第五批骨干节点建设评审会顺利召开" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/16<span>2021</span></div></div>
                            <div class="info">
                                <div class="title">“星火·链网”第五批骨干节点建设评审会顺利召开</div>
                                <div class="desc">2021年9月15日，由中关村区块链产业联盟(以下简称“ABI”)组织召开的“星火·链网”第五批骨干节点建设评审会议顺利召开，本次会议主要评审了广东佛山和珠海横琴两个骨干节点的建设方案。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="/NewsDetail/39" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1646040498893088.jpg" alt="“星火·链网”正式启动，面向全球服务的国家级区块链新型基础设施进入到建设阶段" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">09/03<span>2020</span></div></div>
                            <div class="info">
                                <div class="title">“星火·链网”正式启动，面向全球服务的国家级区块链新型基础设施进入到建设阶段</div>
                                <div class="desc">8月30日下午，“工业互联网标识主题论坛”作为2020工业互联网大会的主题论坛之一，通过20余家直播平台在云端成功举办。论坛上举行了国家区块链与工业互联网协同新型基础设施——“星火·链网”启动仪式。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>